import convert from 'xml-js';
import { IFiling } from './types';

const mapFilingsToTableData = (filings): IFiling[] => {
  const tableData = filings.map((filing, index) => {
    return {
      key: index,
      year: Number(filing.period?._text.substring(0, 4)),
      acc: filing.acc?._text,
      date: filing.datefiled?._text,
      period: filing.period?._text,
      formDescription: filing.form_description?._text,
      form: filing.form?._text,
      formGroup: filing.form_group?._text,
      links: filing.links,
    };
  });
  return tableData;
};

export const convertAndMapXmlFilingsData = (responseXmlData) => {
  const dataJSON = convert.xml2json(responseXmlData, {
    compact: true,
    spaces: 4,
  });
  const parsedJSON = JSON.parse(dataJSON);
  const filings = parsedJSON?.filings?.filing;
  const filingsArr = mapFilingsToTableData(filings).sort((a, b) =>
    b.period.localeCompare(a.period),
  );
  return filingsArr;
};
